import { CategorizedData, DisaggregatedMetric, GeoDetails, GeoTag, Metric } from "../services/types";
import childrenSvg from '../assets/children.svg';
import insuranceSvg from '../assets/insurance.svg';
import familySvg from '../assets/family.svg';
import personOutlineSvg from '../assets/person-outline.svg';
import annualhhincomeSvg from '../assets/annualhhincome.svg';
import houseSvg from '../assets/house.svg';
import houseOutlineSvg from '../assets/house-outline.svg';
import houseCostBurden from '../assets/housing-cost-burden.svg';
import residentTurnoverSvg from '../assets/resident-turnover.svg';
import healthyFoodSvg from '../assets/healthy-food.svg';
import bicycleSvg from '../assets/bicycle.svg';
import languageSvg from '../assets/language.svg';
import peopleSvg from '../assets/people.svg';
import descentSvg from '../assets/descent-group.svg';
import populationSvg from '../assets/population.svg';
import globeSvg from '../assets/globe.svg';

import pop18Svg from '../assets/pop18.svg';
import grandparentsSvg from '../assets/grandparents.svg';
import pop65Svg from '../assets/pop65.svg';
import econFamiliesSvg from '../assets/econ-families.svg';
import chartSvg from '../assets/chart.svg';
// import povertySvg from '../assets/poverty.svg';
// import limitedEngSvg from '../assets/limited-english.svg';
// import collegeSvg from '../assets/college.svg';
// import unemploymentSvg from '../assets/unemploymentrate.svg';
// import homeownerSvg from '../assets/homeowner.svg';
// import renterSvg from '../assets/renter.svg';
// import medianHomeSvg from '../assets/median-home.svg';
// import laborForceSvg from '../assets/laborforce.svg';
// import commuteSvg from '../assets/commute.svg';
// import internetSvg from '../assets/internet.svg';

// SVGR Icons
import childrenSvgr from '../assets/svgr/children.svg?react';
import insuranceSvgr from '../assets/svgr/insurance.svg?react';
import familySvgr from '../assets/svgr/family.svg?react';
import personOutlineSvgr from '../assets/svgr/person-outline.svg?react';
import annualhhincomeSvgr from '../assets/svgr/annualhhincome.svg?react';
import houseSvgr from '../assets/svgr/house.svg?react';
import houseOutlineSvgr from '../assets/svgr/house-outline.svg?react';
import houseCostBurdenSvgr from '../assets/svgr/housing-cost-burden.svg?react';
import residentTurnoverSvgr from '../assets/svgr/resident-turnover.svg?react';
import healthyFoodSvgr from '../assets/svgr/healthy-food.svg?react';
import internetSvgr from '../assets/svgr/internet.svg?react';
import bicycleSvgr from '../assets/svgr/bicycle.svg?react';
import languageSvgr from '../assets/svgr/language.svg?react';
import peopleSvgr from '../assets/svgr/people.svg?react';
import descentSvgr from '../assets/svgr/descent-group.svg?react';
import populationSvgr from '../assets/svgr/population.svg?react';
import globeSvgr from '../assets/svgr/globe.svg?react';

import pop18Svgr from '../assets/svgr/pop18.svg?react';
import grandparentsSvgr from '../assets/svgr/grandparents.svg?react';
import pop65Svgr from '../assets/svgr/pop65.svg?react';
import econFamiliesSvgr from '../assets/svgr/econ-families.svg?react';
import chartSvgr from '../assets/svgr/chart.svg?react';

// PDF Icons
import PersonOutlineIcon from "../components/pdf/icons/PersonOutlineIcon";
import InsuranceIcon from "../components/pdf/icons/InsuranceIcon";
import ChildrenIcon from "../components/pdf/icons/ChildrenIcon";
import FamilyIcon from "../components/pdf/icons/FamilyIcon";
import AnnualHHIncomeIcon from "../components/pdf/icons/AnnualHHIncomeIcon";
import ChartIcon from "../components/pdf/icons/ChartIcon";
import HousingCostBurdenIcon from "../components/pdf/icons/HousingCostBurdenIcon";
import HouseOutlineIcon from "../components/pdf/icons/HouseOutlineIcon";
import ResidentTurnoverIcon from "../components/pdf/icons/ResidentTurnoverIcon";
import HouseIcon from "../components/pdf/icons/HouseIcon";
import HealthyFoodIcon from "../components/pdf/icons/HealthyFoodIcon";
import BicycleIcon from "../components/pdf/icons/BicycleIcon";
import PopulationIcon from "../components/pdf/icons/PopulationIcon";
import Pop18Icon from "../components/pdf/icons/Pop18Icon";
import GrandparentsIcon from "../components/pdf/icons/GrandparentsIcon";
import Pop65Icon from "../components/pdf/icons/Pop65Icon";
import EconFamiliesIcon from "../components/pdf/icons/EconFamiliesIcon";
import GlobeIcon from "../components/pdf/icons/GlobeIcon";
import LanguageIcon from "../components/pdf/icons/LanguageIcon";
import PeopleIcon from "../components/pdf/icons/PeopleIcon";
import DescentIcon from "../components/pdf/icons/DescentIcon";
import { indicatorsEnv, metricsEnv } from "./environment";


// #region Organization Metric Mapping
const organizationMetrics: { [orgId: number]: any[] } =
{ 
    // Casey
    51:
    [
        {
            name: "Child & Family",
            ids: [1078, 1080, 1089, 1091, 1100, 1102, 1103, 1105, 1106, 1108, 1109, 1119],
            order: [
                [1100, 1089, 1102, 1103, 1080, 1091],
                [1119]
            ],
            charts: [
                {
                    name: "singlemothers",
                    id: 1108
                },
                {
                    name: "singlefathers",
                    id: 1109
                },
                {
                    name: "nohealthinsurance",
                    id: 1103
                },
                {
                    name: "childagegroup",
                    id: 1078
                },
                {
                    name: "under5pov",
                    id: 1100
                },
                {
                    name: 'singleparent',
                    id: 1106
                },
                {
                    name: 'childinsurance',
                    id: 1102
                },
                {
                    name: 'popunder18',
                    id: 1089
                },
                {
                    name: 'childadultratio',
                    id: 1119
                }
            ]
        },
        {
            name: "Education",
            ids: [ 1081, 1098, 1101, 1104, 1115 ],
            order: [
                [1081, 1115], // Metric IDs for Age 3 and 4 School Enrollment, 4-Year High School Graduation Rate
                [1098, 1104], // Metric IDs for Age 25+ with HS Dip/GED, Age 25+ without HS Dip/GED
                [1101]  // Metric IDs for Age 25+ with a Bachelor's Degree
            ],
            charts: [
                {
                    name: "hsgrad",
                    id: 1098
                },
                {
                    name: "nohsgrad",
                    id: 1104
                },
                {
                    name: "bachdegree",
                    id: 1101
                },
                {
                    name: "childenrollment",
                    id: 1081
                },
                {
                    name: 'gradrate',
                    id: 1115
                }
            ]
        },
        {
            name: "Housing",
            ids: [ 1071, 1074, 1077, 1079, 1092, 1107],
            order: [
                [1092, 1077, 1079], // Metric IDs for Work Hrs/Week to Rent 2-Bed Home at Minimum Wage, Home Ownership Rate, Vacant Housing, Resident Turnover
                [1074, 1071, 1107]  // Metric IDs for Housing Cost Burden Owners, and Housing Cost Burden Renters
            ],
            charts: [
                {
                    name: "homeownerrate",
                    id: 1092
                },
            ]
        },
        {
            name: "Accessibility",
            ids: [ 1082, 1110, 1111, 1117, 1118],
            order: [
                [1111],
            ],
            charts: [
                {
                    name: "snap",
                    id: 1110
                },
                {
                    name: "computerinternet",
                    id: 1111
                },
                {
                    name: "commutemode",
                    id: 1082
                },
                {
                    name: 'reducedfreelunch',
                    id: 1118
                }
            ]
        },
        {
            name: "Economy",
            ids: [1068, 1069, 1070, 1075, 1076, 1083, 1084, 1085, 1086, 1087, 1093, 1096, 1112, 1116],
            order: [
                [1093, 1112, 1096, 1084],
            ],
            charts: [
                {
                    name: "annualhhinc",
                    id: 1076
                },
                {
                    name: "unemployrate",
                    id: 1112
                },
                {
                    name: 'povrate',
                    id: 1096
                },
                {
                    name: 'hhincnative',
                    id: 1083
                },
                {
                    name: 'hhinchawaiian',
                    id: 1087
                },
                {
                    name: 'hhincwhite',
                    id: 1070
                },
                {
                    name: 'hhincasian',
                    id: 1085
                },
                {
                    name: 'hhincother',
                    id: 1068
                },
                {
                    name: 'hhincblack',
                    id: 1086
                },
                {
                    name: 'hhinctwo',
                    id: 1075
                },
                {
                    name: 'hhinchispanic',
                    id: 1069
                },
                {
                    name: 'currunemployestimate',
                    id: 1116
                }
            ]
        },
        {
            name: "Demographic",
            ids: [1072, 1073, 1088, 1099, 1113, 1114],
            order: [
                [1088, 1099],
            ],
            charts: [
                {
                    name: "race",
                    id: 1088
                },
                {
                    name: "language",
                    id: 1114
                },
                {
                    name: 'ethnicity',
                    id: 1072
                },
                {
                    name: 'latinodescent',
                    id: 1113
                }
            ]
        }
    ],
    
};

// precisionMapping - maps metricId's to the desired number of significant figures for formatting metric values
export const precisionMapping: { [metricId: number]: number } = {
    1078: 0,
    1100: 0,
    1102: 0,
    1103: 0,
    1080: 0,
    1106: 0,
    1108: 0,
    1109: 0,
    1099: 0,
    1092: 0, 
    1077: 0, 
    1079: 0,
    1074: 0,
    1071: 0,
    1089: 0,
    1119: 0,
    1096: 0,
    1083: 0,
    1087: 0,
    1070: 0,
    1068: 0,
    1069: 0,
    1085: 0,
    1086: 0,
    1075: 0,
    1098: 0,
    1101: 0,
    1104: 0,
    1110: 0,
    1076: 0,
    1082: 0,
    1088: 0,
    1072: 0,
    1113: 0,
    1114: 0,
    1081: 0,
    1115: 0,
    1112: 0,
    1084: 0,
    1111: 0,
    1117: 0,
    1118: 0,
};

const svgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Casey
    51: {
        1100: personOutlineSvg,  // Children under 5 in Poverty
        1102: insuranceSvg,  // Children without Health Insurance
        1078: childrenSvg, // Children by Age Group Chart
        1119: familySvg, // Child to Adult Ratio
        1076: annualhhincomeSvg, // Annual Household Income
        1116: chartSvg, // Unemployment Rate Estimate
        1071: houseCostBurden, // Housing Cost Burden Owners
        1074: houseCostBurden,  // Housing Cost Burden Renters
        1077: houseOutlineSvg,    // Vacant Housing
        1079: residentTurnoverSvg, // Resident Turnover
        1092: houseSvg,// Home Ownership Rate
        1107: houseSvg,  // Work Hrs/Week to Rent 2-Bed Home at Minimum Wage
        1117: healthyFoodSvg, // Access to Healthy Food
        1082: bicycleSvg,   // Commute Mode
        1088: populationSvg, // Population
        1099: globeSvg, // Foreign Born
        1114: languageSvg, // Language Spoken in Household
        1072: peopleSvg,      // Latinos by Race
        1113: descentSvg,  // Latinos by Descent Group
    },
    
};

const svgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Casey
    51: {
        1100: personOutlineSvgr,  // Children under 5 in Poverty
        1102: insuranceSvgr,  // Children without Health Insurance
        1103: insuranceSvgr,
        1078: childrenSvgr, // Children by Age Group Chart
        1119: familySvgr, // Child to Adult Ratio
        1076: annualhhincomeSvgr, // Annual Household Income
        1116: chartSvgr, // Unemployment Rate Estimate
        1071: houseCostBurdenSvgr, // Housing Cost Burden Owners
        1074: houseCostBurdenSvgr,  // Housing Cost Burden Renters
        1077: houseOutlineSvgr,    // Vacant Housing
        1079: residentTurnoverSvgr, // Resident Turnover
        1092: houseSvgr,// Home Ownership Rate
        1107: houseSvgr,  // Work Hrs/Week to Rent 2-Bed Home at Minimum Wage
        1117: healthyFoodSvgr, // Access to Healthy Food
        1111: internetSvgr, // Internet Access
        1082: bicycleSvgr,   // Commute Mode
        1088: populationSvgr, // Population
        1099: globeSvgr, // Foreign Born
        1114: languageSvgr, // Language Spoken in Household
        1072: peopleSvgr,      // Latinos by Race
        1113: descentSvgr,  // Latinos by Descent Group
        1089: pop18Svgr,
        1080: grandparentsSvgr,
        1091: pop65Svgr,
        1084: econFamiliesSvgr,

    },
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Casey
    51: {
        1100: personOutlineSvg,  // Children under 5 in Poverty
        1102: insuranceSvg,  // Children without Health Insurance
        1078: childrenSvg, // Children by Age Group Chart
        1119: familySvg, // Child to Adult Ratio
        1076: annualhhincomeSvg, // Annual Household Income
        1116: chartSvg, // Unemployment Rate Estimate
        1071: houseCostBurden, // Housing Cost Burden Owners
        1074: houseCostBurden,  // Housing Cost Burden Renters
        1077: houseOutlineSvg,    // Vacant Housing
        1079: residentTurnoverSvg, // Resident Turnover
        1092: houseSvg,// Home Ownership Rate
        1107: houseSvg,  // Work Hrs/Week to Rent 2-Bed Home at Minimum Wage
        1117: healthyFoodSvg, // Access to Healthy Food
        1082: bicycleSvg,   // Commute Mode
        1088: populationSvg, // Population
        1089: pop18Svg, // Population under 18
        1080: grandparentsSvg, // Grandparents living with Grandchildren
        1091: pop65Svg, // Population 65 and Over
        1084: econFamiliesSvg, // Families under 200% Poverty
        1099: globeSvg, // Foreign Born
        1114: languageSvg, // Language Spoken in Household
        1072: peopleSvg,      // Latinos by Race
        1113: descentSvg,  // Latinos by Descent Group
    },
    
};

const pdfIconMap: { [orgId: number]: { [key: number]: React.FC | null } } = {
  51: {
    1100: PersonOutlineIcon,
    1102: InsuranceIcon,
    1103: InsuranceIcon,
    1078: ChildrenIcon,
    1119: FamilyIcon,
    1076: AnnualHHIncomeIcon,
    1116: ChartIcon,
    1071: HousingCostBurdenIcon,
    1074: HousingCostBurdenIcon,
    1077: HouseOutlineIcon,
    1079: ResidentTurnoverIcon,
    1092: HouseIcon,
    1107: HouseIcon,
    1117: HealthyFoodIcon,
    1082: BicycleIcon,
    1088: PopulationIcon,
    1089: Pop18Icon,
    1080: GrandparentsIcon,
    1091: Pop65Icon,
    1084: EconFamiliesIcon,
    1099: GlobeIcon,
    1114: LanguageIcon,
    1072: PeopleIcon,
    1113: DescentIcon,
  }
};

// #endregion



// getMetricGroupIds - get the metric id values for a specific grouping 
export const getMetricGroupIds = (name: string) => {

    let ids = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            ids = group.ids;
        }
    }

    return ids;
}



// Store our organization Id where we can access it later
export var orgId: number = 51;
export const setOrgId = (id: number) => {
    orgId = id;
}

// Store our overlapping county fips codes for BLS and TRS data queries
export var countyId: string[] = [];
export const setCountyIds = (id: string[]) => {
    countyId = id;
}
export const getCountyIds = () => {
    return countyId;
}



// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgMap = (id: number) => {
    let svg = "";
    if(svgMap[orgId] != undefined){
        svg = svgMap[orgId][id];
    }
    return svg;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(svgrMap[orgId] != undefined){
        return svgrMap[orgId][id];
    }
    return undefined;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgMap = (id: number) => {
    let svg = "";
    if(pdfSvgMap[orgId] != undefined){
        svg = pdfSvgMap[orgId][id];
    }
    return svg;
}

// getPdfIcon - get our icon mapping for the given organization and metric id
export const getPdfIcon = (id: number): React.FC | null => {
  return pdfIconMap[orgId]?.[id] ?? null;
};

// getMetricGroupOrderIds - get the ordering for a metric group
export const getMetricGroupOrderIds = (name: string) => {
    let orderIds = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            orderIds = group.order;
        }
    }

    return orderIds;
}

// getMetricGroupChartId - get a metric id given the group and chart key
export const getMetricGroupChartId = ( group: string, key: string) => {
    let id = -1;

    if(organizationMetrics[orgId] != undefined){
        const g = organizationMetrics[orgId].find((x: { name: string; }) => x.name === group);
        if(g != undefined){
            
            if(g.charts != undefined){

                const chart = g.charts.find((x: { name: string; }) => x.name === key);
                if(chart != undefined){
                    id = chart.id;
                }
            }
        }
    }

    return id;
}

// // getInteractionsLayerId - each organization will have its own interactions layer id
// // Updated to query by interaction tag to remove hard-coding
// export const getInteractionsLayerId = async () => {

//     var layerId = '';

//     const endpoint = `https://t47lzv8rn2.execute-api.us-east-1.amazonaws.com/staging/layers/search?organizationId=${orgId}&tags=ado_business_interactions`;
//     let searchLayerResponse = await fetch(endpoint, { method: 'GET' });
//     const layerDetails = await searchLayerResponse.json();
//     console.log("layer details: ", layerDetails);
//     layerId = layerDetails.data[0].layer_id;
//     console.log("orgId, layerId: ", orgId, layerId);


//     // Legacy - remove when reference no longer needed
//     // switch(orgId){
//     //     case 12: layerId = '25'; break;
//     //     case 13: layerId = '29'; break;
//     //     case 14: layerId = '30'; break;
//     //     default: layerId = '25';
//     // }

//     return layerId;
// };

export const categorizeData = (indicators: DisaggregatedMetric[]) => {

    const categories = {
        "Child & Family": getMetricGroupIds("Child & Family"),
        Education: getMetricGroupIds("Education"),
        Economy: getMetricGroupIds("Economy"), 
        Housing: getMetricGroupIds("Housing"),
        Accessibility: getMetricGroupIds("Accessibility"),
        Demographic: getMetricGroupIds("Demographic"),
    };

    const categorizedData = {
        "Child & Family": [] as Metric[],
        Education: [] as Metric[],
        Economy: [] as Metric[],
        Housing: [] as Metric[],
        Accessibility: [] as Metric[],
        Demographic: [] as Metric[],
    };

    // Filter out metric 399 from disaggregatedData
    // const filteredData = disaggregatedData.filter(item => item.id !== 399);

    indicators.forEach((item) => {
        if (categories["Child & Family"].includes(item.id)) {
            categorizedData["Child & Family"].push(item);
        } else if (categories.Education.includes(item.id)) {
            categorizedData.Education.push(item);
        } else if (categories.Economy.includes(item.id)) {
            categorizedData.Economy.push(item);
        } else if (categories.Housing.includes(item.id)) {
            categorizedData.Housing.push(item);
        } else if (categories.Housing.includes(item.id)) {
            categorizedData.Housing.push(item);
        } else if (categories.Accessibility.includes(item.id)) {
            categorizedData.Accessibility.push(item);
        } else if (categories.Demographic.includes(item.id)) {
            categorizedData.Demographic.push(item);
        }
    });

    return categorizedData;
};

export const fetchMetricMetadata = async (id: number) => {
    if (!id) {
        console.log('No id provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetricmetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadataByOrg = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetadatabyorg`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orgId, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetchStateData - retreive state data for a selected metric using a prefix state code
export const fetchStateData = async (metricId: number, disaggregated: boolean, geoPrefix: string) => {
    if (!metricId || !geoPrefix) {
        console.log('No metricId or geoDetails provided to fetch metric state data');
        return;
    }

    console.log('geoprefix:', geoPrefix);

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoPrefix, disaggregated, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric state data:', error);
    }
};

// fetchNationalData - retreive national data for a selected metric
export const fetchNationalData = async (metricId: number, disaggregated: boolean) => {
    if (!metricId) {
        console.log('No metricId provided to fetch national metric data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, disaggregated, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching national metric data:', error);
    }
};

// Safely derive a 2-digit prefix from any geoId form
export const getGeoPrefix = (
  geoId: string | number | string[] | null | undefined
): string | undefined => {
    if (geoId == null) return undefined;

    // Handle arrays like ["53"]
    const firstValue = Array.isArray(geoId) ? geoId[0] : geoId;
    if (firstValue == null) return undefined;

    const s = String(firstValue);
    return s.slice(0, 2) || undefined;
};

// Find the most common 2-digit prefix among provided GeoDetails
export const calculateGeoPrefix = (geoDetails: GeoDetails[] = []): string | undefined => {
    const prefixCount = new Map<string, number>();

    geoDetails.forEach(geo => {
        if (!Array.isArray(geo.ids)) return;

        geo.ids.forEach(geoId => {
        const prefix = getGeoPrefix(geoId);
        if (!prefix) return; // skip invalid entries
        prefixCount.set(prefix, (prefixCount.get(prefix) || 0) + 1);
        });
    });

    // Select the prefix with the highest count
    let mostCommonPrefix: string | undefined;
    let maxCount = 0;

    for (const [prefix, count] of prefixCount) {
        if (count > maxCount) {
        mostCommonPrefix = prefix;
        maxCount = count;
        }
    }

    return mostCommonPrefix;
};

export const fetchMetricsData = async (tabs: string[], geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
  const geoEncoding = 'delta';
  const indicatorsUrl = `${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getallindicatorsv2`;

  const lowerTabs = tabs.map(tab => tab.toLowerCase());

  const fetchPromises = lowerTabs.map(category =>
    fetch(indicatorsUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        geoDetails,
        orgId: 51,
        dashboardView: category,
        geoEncoding,
        geoTag,
        environment: indicatorsEnv
      }),
    }).then(res => {
      if (!res.ok) throw new Error(`Failed to fetch data for ${category}`);
      return res.json();
    })
  );

  const results = await Promise.all(fetchPromises);
  return results.flat(); // returns DisaggregatedMetric[]
};

// Transform a metric's disaggregations into simple label/value pairs for charts
interface LineChartPoint { label: string; value: number; }

const buildLineChartPoints = (metric?: DisaggregatedMetric): LineChartPoint[] => {
  if (!metric) return [];
  const version = metric.versions[0];
  if (!version) return [];

  const tallyMap = new Map<string, number>();

  version.disaggregations.forEach(d => {
    let percentage: number;
    switch (version.unit) {
      case 'integer':
        percentage = version.value ? d.value / version.value : 0;
        break;
      case 'percentage':
        percentage = Math.min(d.value, 1);
        break;
      case 'decimal':
      case 'ratio':
        percentage = d.value;
        break;
      default:
        percentage = 0;
    }
    tallyMap.set(d.name.trim(), percentage);
  });

  return Array.from(tallyMap.entries()).map(([label, value]) => ({ label, value }));
};

// Fetch and prepare data for the Unemployment Rate comparison chart
export const fetchUnemploymentRateChartData = async (
  geoDetails: GeoDetails[],
  geoTag: GeoTag | null,
  disaggregatedData: DisaggregatedMetric[],
) => {
  const metricId = 1116;
  
  const geoPrefix: string | undefined = geoTag?.value
    ? getGeoPrefix(geoTag.value)
    : calculateGeoPrefix(geoDetails);

  const selectedMetric = disaggregatedData.find(m => m.id === metricId);
  const data = buildLineChartPoints(selectedMetric);

  const statePromise = geoPrefix
    ? fetchStateData(metricId, true, geoPrefix)   // only call when we have a prefix
    : Promise.resolve<null>(null);

  const [stateRes, nationalRes] = await Promise.all([
    statePromise,
    fetchNationalData(metricId, true),
  ]);

  const stateMetric = stateRes?.data ? stateRes.data[0] : undefined;
  const nationalMetric = nationalRes?.data ? nationalRes.data[0] : undefined;

  const stateData = buildLineChartPoints(stateMetric);
  const nationalData = buildLineChartPoints(nationalMetric);

  return { data, stateData, nationalData };
};

// Helper function to get and sort metrics by category
export const getSortedMetrics = (category: string, categorizedData: CategorizedData) => {
    const orders = getMetricGroupOrderIds(category);

    return orders.map((order: number[]) => 
        categorizedData[category]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};